/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import {
    getRevenueFromSubscriptionData, handleLoader
} from '../../../../redux/actions/RevenueFromSubscriptionActions';
import { setCurrencyFormat, findMonthsBetweenDates } from '../../../../utils/helpers';
import { months, filterShowWise, tableRevenueFromSubscriptionHeader, sortType } from '../../helper';
import MonthlyBarChart from './RevenueFromSubMonthBarChart';
import MonthlySubsSalesCategoryWise from './MonthlySubsSalesCategoryWise';
import ViewSalesReportModal from './ViewSalesReportModal';


const RevenueFromSubscription = ({ dispatch, rtl }) => {
    const { t } = useTranslation('common');
    const location = useLocation();

    const [currentYear, currentMonth] = moment().format('YYYY-MMM').split('-');
    const [prevYear, prevMonth] = moment().subtract(5, 'months').format('YYYY-MMM').split('-');

    const { isLoading, revenueFromSubscriptionData, salesChannelFilterData } = useSelector(
        ({ revenueFromSubscriptionReducer, marketPlaceReducer }) =>
        ({
            salesChannelFilterData: marketPlaceReducer.salesChannel,
            revenueFromSubscriptionData: revenueFromSubscriptionReducer.revenueFromSubscriptionData,
            isLoading: revenueFromSubscriptionReducer.isLoading,
        })
    );

    const filtersObj = revenueFromSubscriptionData?.modal?.filters?.[0];

    const [revenueFromSubscriptionDataToShow, setProfitDataToShow] = useState([]);
    const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[0]);
    const [isOpen, setIsOpen] = useState(false);

    const [filterData, setFilterData] = useState({});
    const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth });
    const [month1, setMonth1] = useState({ year: prevYear, month: prevMonth })
    const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
    const [tempMonth1, setTempMonth1] = useState({ year: prevYear, month: prevMonth })

    const yearOptions = [];
    for (let year = 2016; year <= currentYear; year += 1) {
        yearOptions.push({ label: year, value: year })
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 10,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvHDF = document.getElementById('dvHeaderFilter');
    const dvTb = document.getElementById('dvTable');
    const dvChartF = document.getElementById('dvChartFilter');
    const dvChartV = document.getElementById('dvChartView');
    dvHDF.style.display = "none";
    dvTb.style.display = "none";  
    dvChartF.style.display = "none";  
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Revenue From Subscription Report ${new Date().getFullYear()}`,
    })
    dvHDF.style.display = "block";
    dvTb.style.display = "block";  
    dvChartF.style.display = "block";  
    dvChartV.style.display = "block"; 
  }

    const filterBasedOnFilter = (item, segregatedData) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        };

        if (flag && Number(item?.subscribed)) {
            segregatedData.subscribed.push(item)
            segregatedData.totalRevenue += Number(item.amount)
            segregatedData.subscribedRevenue += Number(item.amount);
            if (item?.salesMonth && segregatedData?.subscribedMonthWise[item.salesMonth]) {
                segregatedData.subscribedMonthWise[item.salesMonth]?.push(item)
            } else {
                segregatedData.subscribedMonthWise[item.salesMonth] = [item]
            }
        } else if (flag) {
            segregatedData.unsubscribed.push(item)
            segregatedData.totalRevenue += Number(item.amount)
            if (item?.salesMonth && segregatedData?.unsubscribedMonthWise[item.salesMonth]) {
                segregatedData.unsubscribedMonthWise[item.salesMonth]?.push(item)
            } else {
                segregatedData.unsubscribedMonthWise[item.salesMonth] = [item]
            }
        }

        return flag
    }

    const monthOptions = months.map(item => ({ label: item, value: item }));
    const date1 = `${month1?.year}-${month1?.month}`;
    const date2 = `${month2?.year}-${month2?.month}`;
    const segregatedData = {
        subscribed: [], unsubscribed: [],
        subscribedMonthWise: {}, unsubscribedMonthWise: {},
        totalRevenue: 0, subscribedRevenue: 0
    }

    let revenueFromSubscriptionDataToShowDates = [];

    const monthsBetweenDates = findMonthsBetweenDates(date1, date2);
    for (let i = 0; i < monthsBetweenDates.length; i += 1) {
        const [year, month] = monthsBetweenDates?.[i]?.split('-');
        let monthWiseData = revenueFromSubscriptionDataToShow?.[year]?.monthlyProductSales?.[month] ?? [];
        if (monthWiseData) {
            monthWiseData = monthWiseData.map((item) => {
                const updated = {
                    ...item,
                    salesMonth: month,
                    salesYear: year,
                    year, month,
                    subscribedText: item.subscribed === "1" ? 'Yes' : 'No'

                }
                return updated
            }).filter(updated =>
                filterBasedOnFilter(updated, segregatedData)
            )
            revenueFromSubscriptionDataToShowDates = revenueFromSubscriptionDataToShowDates?.concat(monthWiseData);
        }
    }

    const viewReportButton = () => (
        <div className="view-report" style={{ right: '15px', top: '10px' }}>
            <button
                type="button"
                className="view-report btn btn-primary btn-sm"
                onClick={() => setIsOpen(true)}
            >
                View Report
            </button>
        </div>
    )

    const handleCountry = (event) => {
        const filter = []
        if(event?.length && event[0].value === 'UK')
        {
            // filter.push(event)
            filter.push({
                "label": event[0].label,
                "value": "BG"
            })
        }
        else {
            filter.push(event)
        }

        setFilterData({
            ...filterData,
            [filtersObj?.applyToColumn]: filter[0]
        })
    }

    const callApi = ({ tempMon1, tempMon2 }) => {
        const data = {
            from: tempMon1?.year, to: tempMon2?.year,
            fromMonth: moment(tempMon1?.month, 'MMM').format('MMM'),
            toMonth: moment(tempMon2?.month, 'MMM').format('MMM'),
        }
        dispatch(handleLoader(true))
        dispatch(getRevenueFromSubscriptionData(data));
    }

    const handleApplyDate = () => {
        const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
        const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

        const monthsBetween = findMonthsBetweenDates(startDate, endDate);
        if (monthsBetween?.length > 0 && monthsBetween?.length <= 12) {
            setMonth1(tempMonth1);
            setMonth2(tempMonth2);
            callApi({ tempMon1: tempMonth1, tempMon2: tempMonth2 });
        } else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'Please select maximum one year data'
                });
            });
        }
    }

    const handleYearMonthChange = ({ isFrom, field, value }) => {

        if (isFrom) {
            setTempMonth1({ ...tempMonth1, [field]: value?.value });
        } else {
            setTempMonth2({ ...tempMonth2, [field]: value?.value });
        }
    }

    const calculateSubsSalesPercentage = () => {
        const { totalRevenue, subscribedRevenue } = segregatedData;
        if (totalRevenue) {
            return `${(Number((subscribedRevenue / totalRevenue) * 100).toFixed(2))} %`
        }
        return '0%'
    }

    // eslint-disable-next-line react/prop-types
    const RenderYearAndMonth = ({ isFrom }) => (
        <Col sm="4" className="pr-0">
            <Row className="align-items-center">
                <Col sm="5" className="">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Year</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                                    : { value: tempMonth2?.year, label: tempMonth2?.year }}
                                options={yearOptions}
                                clearable={false}
                                placeholder="Select Year"
                                className="select_filter-110"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'from' : 'to'}
                            />
                        </div>

                    </div>
                </Col>
                <Col sm="5" className="">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Month</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                                    : { value: tempMonth2?.month, label: tempMonth2?.month }}
                                options={monthOptions}
                                clearable={false}
                                placeholder="Select Month"
                                className="select_filter-110"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'fromMonth' : 'toMonth'}
                            />
                        </div>
                    </div>
                </Col>
                {isFrom ? <Col sm="2" className="top-10 text-center">~</Col> : null}
            </Row>

        </Col>
    );

    const changeFilter = (value) => {
        setCurrentlyShow(value)
    };

    useEffect(() => {
        dispatch(handleLoader(true));
        callApi({ tempMon1: tempMonth1, tempMon2: tempMonth2 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setProfitDataToShow(revenueFromSubscriptionData?.modal?.data?.[0]?.yearlySales || []);
    }, [revenueFromSubscriptionData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData]);

    const tableHeader = [...tableRevenueFromSubscriptionHeader]
    tableHeader.splice(2, 0, {
        Header: 'Subscribed',
        accessor: 'subscribedText',
        disableGlobalFilter: false,
        width: 100,
        sortType
    });

    if (currentlyShow?.value === 'productCategory') {
        tableHeader.splice(3, 0, {
            Header: 'Product Category',
            accessor: 'productCategory',
            disableGlobalFilter: false,
            width: 180,
            sortType
        })
    }

    if (currentlyShow?.value === 'productSubCategory') {
        tableHeader.splice(3, 0, {
            Header: 'Product Sub Category',
            accessor: 'productSubCategory',
            disableGlobalFilter: false,
            width: 200,
            sortType
        })
    }

    if (currentlyShow?.value === 'productCollection') {
        tableHeader.splice(3, 0, {
            Header: 'Product Collection',
            accessor: 'productCollection',
            disableGlobalFilter: false,
            width: 180,
            sortType
        })
    }

    console.log("d:", filtersObj)
    console.log("data:", filterData)

    return (
        <Container className="dashboard">
            <div id="divToPrint" ref={container}>
            <Row className="monthly-subscription-order monthlySubsSales">
                <Col sm="12" id='dvHeaderFilter'>
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">Revenue From Subscription</h5>
                            </div>
                            <Row className="align-items-center">
                                <Col md="3">
                                    <Row>
                                        <Col md="6">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">Country</span>
                                                <div className="form__form-group-field">
                                                    <Select
                                                        value={filterData?.country || []}
                                                        options={filtersObj?.filterData?.map(countr =>
                                                            ({ label: countr.longValue, value: countr.key }))}
                                                        clearable={false}
                                                        placeholder="Select Country"
                                                        className="select_filter"
                                                        onChange={value => handleCountry(value)}
                                                        // onChange={value => setFilterData({
                                                        //     ...filterData,
                                                        //     [filtersObj?.applyToColumn]: value
                                                        // })}
                                                        classNamePrefix="react-select"
                                                        isMulti
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="6" className="pr-0">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">Show</span>
                                                <div className="form__form-group-field">
                                                    <Select
                                                        value={currentlyShow}
                                                        options={filterShowWise}
                                                        clearable={false}
                                                        placeholder="Select "
                                                        className="select_filter"
                                                        onChange={value => changeFilter(value)}
                                                        classNamePrefix="react-select"
                                                    />
                                                </div>

                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="9">
                                    <Row className="justify-content-center align-items-center">
                                        <RenderYearAndMonth isFrom />
                                        <RenderYearAndMonth />
                                        <Col sm="4" style={{ top: '10px' }}>
                                            <button className="btn btn-sm btn-primary apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                                <button className="btn btn-sm btn-primary
                                             apply-date-button" type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                        </Col>
                                        
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody style={{ background: isLoading ? "#fff" : "rgb(0, 128, 128)" }}>
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div> :
                                <Row className="justify-content-center align-items-center">
                                    <Col sm="6" md="4" lg="4">
                                        <Card body>
                                            <CardTitle className="bold-text" tag="h5"
                                                style={{ color: '#6794DC' }}>
                                                Total Revenue</CardTitle>
                                            <CardText style={{ color: '#6794DC' }}>
                                                {setCurrencyFormat(
                                                    Number(segregatedData?.totalRevenue).toFixed(2), true)}
                                            </CardText>
                                        </Card>
                                    </Col>
                                    <Col sm="6" md="4" lg="4">
                                        <Card body>
                                            <CardTitle className="bold-text" tag="h5" style={{ color: "#DC67CE" }}>
                                                Revenue from subs</CardTitle>
                                            <CardText style={{ color: "#DC67CE" }}>
                                                {setCurrencyFormat(
                                                    Number(segregatedData?.subscribedRevenue).toFixed(2), true)}
                                            </CardText>
                                        </Card>
                                    </Col>
                                    <Col sm="6" md="4" lg="4">
                                        <Card body>
                                            <CardTitle className="bold-text" tag="h5" style={{ color: '#3366ff' }}>
                                                Subs Sales %</CardTitle>
                                            <CardText style={{ color: '#3366ff' }}>
                                                {calculateSubsSalesPercentage()}
                                            </CardText>
                                        </Card>
                                    </Col>

                                </Row>}
                        </CardBody>
                    </Card>
                </Col>
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="p-0">
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div> :
                                <Row className="justify-content-center align-items-center">
                                    <Col sm="12">
                                        <CardBody>
                                            <div>
                                                <MonthlyBarChart
                                                    subscribedMonthWise={segregatedData.subscribedMonthWise}
                                                    unsubscribedMonthWise={segregatedData.unsubscribedMonthWise}
                                                    height={400}
                                                    showTitle
                                                    dir={rtl.direction}
                                                    monthsBetweenDates={monthsBetweenDates}
                                                />
                                            </div>

                                        </CardBody>
                                    </Col>

                                </Row>}
                        </CardBody>
                    </Card>
                </Col>
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="p-0">
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div> :
                                <Row>
                                    <div id='dvChartView'>
                                    {viewReportButton()}</div>
                                    <MonthlySubsSalesCategoryWise
                                        dir={rtl.direction}
                                        height={400}
                                        subscribed={segregatedData.subscribed}
                                        unsubscribed={segregatedData.unsubscribed}
                                        filterData={filterData}
                                        title={`Revenue from subscription by ${currentlyShow?.label}`}
                                        categorisedBasedOn={currentlyShow?.value}
                                        currentlyShow={currentlyShow}
                                        monthsBetweenDates={monthsBetweenDates}

                                    />
                                </Row>}
                        </CardBody>
                    </Card>
                </Col>
                
            </Row>
            </div>
            <ViewSalesReportModal
                modalData={revenueFromSubscriptionDataToShowDates}
                isOpen={isOpen}
                handleModal={setIsOpen}
                fileName="RevenueFromSubscriptionSales"
                title={`Revenue from subscription by ${currentlyShow?.label}`}
                currentlyShow={currentlyShow}
                tableHeaderData={tableHeader} />

        </Container>
    );
};

RevenueFromSubscription.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
};

export default connect(state => ({
    rtl: state.rtl,
}))(RevenueFromSubscription);
